import { render, staticRenderFns } from "./AddNewBook.vue?vue&type=template&id=0028a76e&"
import script from "./AddNewBook.vue?vue&type=script&lang=js&"
export * from "./AddNewBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports